<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<p class="center"><span class="big0">     Jelly Roll</span></p>
<p class="center"><span class="big01">Inspirations</span></p>
<p class="right"><span class="small">COMPILED BY</span><br/><strong>Pam and Nicky Lintott</strong><br/><br/><br/><br/><br/><br/><br/><br/><br/></p>
<p class="center"><img alt="" src="OEBPS/images/logo1.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781446350935_epub_tp_r1.vue?0ee5224a